/* ROMPE TU RUTINA — interacciones (prefijo rtr-) */
(function () {
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.rtr-reveal:not(.rtr-visible)'));
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('rtr-visible'); });
      return;
    }
    var ticking = false;
    function check() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els = els.filter(function (el) {
        var r = el.getBoundingClientRect();
        // se muestra cuando entra en pantalla (o ya quedó por encima)
        if (r.top < vh * 0.94) { el.classList.add('rtr-visible'); return false; }
        return true;
      });
      if (!els.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
    // red de seguridad: si algo falla, a los 10 s todo se muestra
    setTimeout(function () { els.forEach(function (el) { el.classList.add('rtr-visible'); }); els = []; }, 10000);
  }

  function initGaleria() {
    document.querySelectorAll('[data-rtr-gal]').forEach(function (gal) {
      var main = gal.querySelector('[data-rtr-gal-main]');
      if (!main) return;
      gal.querySelectorAll('[data-rtr-gal-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-rtr-gal-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
          main.style.opacity = '0';
          var src = btn.getAttribute('data-src'), srcset = btn.getAttribute('data-srcset'), alt = btn.getAttribute('data-alt') || '';
          setTimeout(function () {
            main.src = src; if (srcset) main.srcset = srcset; main.alt = alt; main.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function initCarrusel() {
    document.querySelectorAll('[data-rtr-carr]').forEach(function (c) {
      if (c.getAttribute('data-ready')) return;
      c.setAttribute('data-ready', '1');
      var t = c.querySelector('[data-rtr-carr-track]');
      function paso() { var s = t.querySelector('.rtr-slide'); return s ? s.getBoundingClientRect().width + 14 : 300; }
      var p = c.querySelector('[data-rtr-carr-prev]'), n = c.querySelector('[data-rtr-carr-next]');
      if (p) p.addEventListener('click', function () { t.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () {
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 8) t.scrollTo({ left: 0, behavior: 'smooth' });
        else t.scrollBy({ left: paso(), behavior: 'smooth' });
      });
    });
  }

  /* Producto digital: nunca más de 1 unidad en la cesta */
  function soloUno() {
    document.querySelectorAll('form[data-rtr-solouno]').forEach(function (f) {
      if (f.getAttribute('data-ready')) return;
      f.setAttribute('data-ready', '1');
      f.addEventListener('submit', function (e) {
        var caja = f.querySelector('[data-rtr-consent]');
        if (caja) {
          var envoltorio = f.querySelector('[data-rtr-consent-wrap]'), aviso = f.querySelector('[data-rtr-consent-error]');
          if (!caja.checked) {
            e.preventDefault(); e.stopImmediatePropagation();
            if (envoltorio) envoltorio.classList.add('rtr-consent--error');
            if (aviso) aviso.hidden = false;
            caja.focus();
            return;
          }
          if (envoltorio) envoltorio.classList.remove('rtr-consent--error');
          if (aviso) aviso.hidden = true;
        }
        var id = f.querySelector('[name="id"]');
        if (!id || !window.fetch) return;
        e.preventDefault();
        var btn = f.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        var json = { 'Content-Type': 'application/json' };
        fetch('/cart/clear.js', { method: 'POST', headers: json })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(id.value), quantity: 1 }] }) }); })
          .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
          .catch(function () { f.setAttribute('data-ready', '1'); f.submit(); });
      });
    });
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var mal = c.items.filter(function (i) { return i.quantity > 1; });
      if (!mal.length) return;
      var upd = {}; mal.forEach(function (i) { upd[i.key] = 1; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(function () { if (/\/cart/.test(location.pathname)) location.reload(); });
    }).catch(function () {});
  }

  /* Hero: las 8 portadas pasan en bucle, salen por la izquierda y entran por la derecha */
  function initHeroCarrusel() {
    document.querySelectorAll('[data-rtr-hs]').forEach(function (c) {
      if (c.getAttribute('data-ready')) return;
      c.setAttribute('data-ready', '1');
      var track = c.querySelector('[data-rtr-hs-track]');
      var orig = Array.prototype.slice.call(track.children), n = orig.length;
      var dots = c.querySelectorAll('[data-rtr-hs-dots] button');
      var seg = (parseInt(c.getAttribute('data-seg'), 10) || 5) * 1000;
      function clones() { return orig.map(function (el) { var k = el.cloneNode(true); k.setAttribute('aria-hidden', 'true'); var im = k.querySelector('img'); if (im) im.setAttribute('loading', 'eager'); return k; }); }
      clones().forEach(function (k) { track.insertBefore(k, orig[0]); });
      clones().forEach(function (k) { track.appendChild(k); });
      var i = n, timer = null, busy = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function marca() { dots.forEach(function (d, k) { d.setAttribute('aria-current', k === (i % n) ? 'true' : 'false'); }); }
      function pon(k, anim) {
        i = k; track.classList.toggle('rtr-hs--anim', anim !== false);
        c.style.setProperty('--i', i); marca();
      }
      function normaliza() {
        if (i >= 2 * n) pon(i - n, false);
        else if (i < n) pon(i + n, false);
        busy = false;
      }
      function mueve(k) { if (busy) return; busy = true; pon(k); setTimeout(normaliza, 480); }
      function sig() { mueve(i + 1); }
      function ant() { mueve(i - 1); }
      function arranca() { if (reduce || timer) return; timer = setInterval(function () { if (!document.hidden) sig(); }, seg); }
      function para() { clearInterval(timer); timer = null; }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { para(); mueve(n + k); arranca(); }); });
      var x0 = null;
      c.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; para(); }, { passive: true });
      c.addEventListener('touchend', function (e) {
        if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { if (dx < 0) sig(); else ant(); } }
        x0 = null; arranca();
      }, { passive: true });
      pon(i, false); arranca();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleria();
    initCarrusel();
    initHeroCarrusel();
    soloUno();
  });
  document.addEventListener('shopify:section:load', function () { initReveal(); initGaleria(); initCarrusel(); initHeroCarrusel(); soloUno(); });
})();
